import {EventEmitter, Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {takeUntil} from 'rxjs/operators';

import {CodeSearchStoreService} from './code-search-store.service';

@Injectable({
  providedIn: 'root'
})
export class CodeSearchFirebaseService {
  private readonly unsubscribe = new EventEmitter();

  constructor(
    private readonly codeSearchStore: CodeSearchStoreService,
    private firestore: AngularFirestore
  ) {}

  public subscribeToCodeSearchLoadFirestore(callback: any) {
    const {path, type} = this.codeSearchStore.getFirebaseLoadingKey();
    console.log('path');
    console.log(path);
    this.firestore
      .doc(path)
      .valueChanges()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((value) => {
        console.log('values');
        console.log(value?.[type]?.lookup?.progress);
        callback(value?.[type]?.lookup?.progress);
      });
  }

  public unsubscribeFromCodeSearchLoadFirestore(): void {
    this.unsubscribe.emit(true);
  }
}
